import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthLayout from '../../components/auth/AuthLayout';
import AuthInput  from '../../components/ui/AuthInput';
import AuthButton from '../../components/ui/AuthButton';
import { useAuth } from '../../contexts/AuthContext'; // Assuming you'll have an AuthContext

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth(); // From your AuthContext
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    if (!email || !password) {
      setError('Please enter both email and password.');
      setIsLoading(false);
      return;
    }

    // --- API Call ---
    try {
      await login(email, password); // Your actual login function from AuthContext
      // If successful, AuthContext should handle navigation or state update
      // For example, you might navigate based on AuthContext's isAuthenticated state in a useEffect
      // For now, let's assume login function in AuthContext handles redirection or state that triggers redirect
      navigate('/admin/dashboard'); // Or wherever you redirect after login
    } catch (err) {
      const errorMessage = err.response?.data?.message || err.message || "Invalid email or password.";
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
    // --- End API Call ---
  };

  return (
    <AuthLayout title="Log In to Quality Air Houston">
      <form onSubmit={handleLogin} className="space-y-6">
        {error && (
          <div className="bg-red-50 border-l-4 border-red-400 p-4">
            <div className="flex">
              <div className="flex-shrink-0">
                {/* <ExclamationTriangleIcon className="h-5 w-5 text-red-400" aria-hidden="true" /> */}
              </div>
              <div className="ml-3">
                <p className="text-sm text-red-700">{error}</p>
              </div>
            </div>
          </div>
        )}

        <AuthInput
          label="Email Address"
          name="email"
          type="email"
          autoComplete="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <AuthInput
          label="Password"
          name="password"
          type={isPasswordVisible ? "text" : "password"}
          autoComplete="current-password"
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          showPasswordToggle
          isPasswordVisible={isPasswordVisible}
          onTogglePasswordVisibility={() => setIsPasswordVisible(!isPasswordVisible)}
        />

        <div className="flex items-center justify-between text-sm">
          <div className="flex items-center">
            {/* <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-brand-accent-orange border-gray-300 rounded focus:ring-brand-accent-orange" />
            <label htmlFor="remember-me" className="ml-2 block text-gray-900"> Remember me </label> */}
          </div>
          <Link to="/forgot-password" className="font-medium text-brand-green-dark hover:text-brand-green-darker">
            Forgot your password?
          </Link>
        </div>

        <AuthButton type="submit" isLoading={isLoading} fullWidth>
          Log In
        </AuthButton>

        <p className="text-sm text-center text-gray-600">
          Don't have an account?{' '}
          <Link to="/register" className="font-semibold text-brand-accent-orange hover:text-orange-500">
            Sign Up
          </Link>
        </p>
      </form>
    </AuthLayout>
  );
};

export default LoginPage;